/*
  KP: QUICK ADD (the round "+" on product tiles, and the panel it opens).

  A. THE PANEL uses the same picker as the product page. The theme's quick add panel
     holds the product's own form with plain dropdowns (Model, Case Type). It is the same
     kind of form the product page has, so the product page's picker
     (assets/kp-product-picker.js and .css) can dress it exactly as it does there: the
     searchable model list, the case type cards with their photos and prices, the
     full-width rounded Add to Cart with no quantity box. Nothing about how the panel
     adds to the cart is changed; the picker only sets the form's own dropdowns.

     SPEED: the picker's two files are NOT loaded with the page. They are fetched the
     first time a "+" is pressed (starting at the press itself, so they are usually there
     by the time the panel has opened), and kept after that. Pages where nobody presses
     "+" pay nothing. (On product pages the picker is already loaded, so nothing extra is
     fetched there.) Where the two files live is handed over by
     snippets/theme-globals.liquid in "KP_QUICK_ADD".

     Once the picker's script is in the page it is told to look again with the theme's
     own "a section was loaded" signal, which is what it already listens for.

  B. THE "+" BUTTON IS THE THEME'S ORIGINAL ONE: a small pale disc with a soft shadow and
     a pale plus. Two restyles were tried on 8 Oct 2026 (a white disc with a black
     outline, then a cream disc) and Sana preferred the original. The first restyle is
     still written in assets/kp-skin.css, section 4 (the two rules for
     ".product-item .product-item__quick-add"); the style at the bottom of this file
     cancels it by putting the theme's own size, shadow and colours back. When
     kp-skin.css is next edited, delete those two rules there and the cancelling style
     here.

  Loaded on every page by snippets/theme-globals.liquid. Delete its lines there to go back
  to the theme's plain quick add panel.
*/
(function () {
  var config = window.KP_QUICK_ADD || {};
  // 0: picker files not asked for. 1: on their way. 2: in the page.
  var loaded = 0;

  function pickerInPage() {
    return loaded === 2 || !!document.querySelector('script[src*="kp-product-picker.js"]');
  }

  // Tell the picker to look for forms it has not dressed yet.
  function announce() {
    try {
      document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: 'kp-quick-add' } }));
    } catch (e) {}
  }

  // Fetch the picker's files (once).
  function fetchPicker(done) {
    if (pickerInPage()) {
      loaded = 2;
      if (done) done();
      return;
    }

    if (loaded === 1 || !config.js) return;
    loaded = 1;

    if (config.css) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = config.css;
      document.head.appendChild(link);
    }

    var script = document.createElement('script');
    script.src = config.js;
    script.onload = function () {
      loaded = 2;
      if (done) done();
    };
    script.onerror = function () {
      loaded = 0;
    };
    document.head.appendChild(script);
  }

  // Is there an open panel whose form still has the plain dropdowns?
  function plainForm() {
    var wrappers = document.querySelectorAll('.quick-product-modal .product__variants-wrapper');

    for (var i = 0; i < wrappers.length; i++) {
      if (!wrappers[i].classList.contains('kp-pp-on') && wrappers[i].querySelector('select[name^="options["]')) return true;
    }

    return false;
  }

  // After a "+" is pressed: the theme fetches the product and fills the panel a moment
  // later, so look for the form a few times a second for a few seconds, and dress it as
  // soon as both it and the picker are there.
  var watching = null;

  function watch() {
    var tries = 0;
    window.clearInterval(watching);

    watching = window.setInterval(function () {
      tries += 1;

      if (plainForm()) {
        if (pickerInPage()) announce();
        else fetchPicker(announce);
      }

      if (tries > 50) window.clearInterval(watching);
    }, 120);
  }

  function isPlus(event) {
    return !!(event.target && event.target.closest && event.target.closest('.product-item__quick-add, .product-item__quick-add-count'));
  }

  // The press itself: start fetching the picker straight away.
  document.addEventListener(
    'pointerdown',
    function (event) {
      if (isPlus(event)) fetchPicker();
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'click',
    function (event) {
      if (isPlus(event)) watch();
    },
    true
  );

  /* ---- B. The "+" button back to the theme's own look; two small touches to the panel ---- */

  var style = document.createElement('style');
  style.textContent = [
    /* Cancels the restyle in kp-skin.css section 4: the theme's own size, no outline, its
       soft shadow, and the plus in the button's own pale colour. */
    '.product-item .product-item__quick-add{width:var(--round-button-size,36px)!important;height:var(--round-button-size,36px)!important;border:0!important;box-shadow:0 1px 1px rgba(0,0,0,.1),0 1px 4px rgba(0,0,0,.15)!important}',
    '.product-item .product-item__quick-add .icon{color:inherit!important}',
    /* The panel: a slightly stronger title, and the picker close under the price. */
    '.quick-product-modal .product__title{font-weight:700}',
    '.quick-product-modal .product__variants-wrapper.kp-pp-on{margin-top:4px}'
  ].join('');
  document.head.appendChild(style);
})();
